import React, { useState, useEffect } from "react";

import SlideMainTitle from "../slides-components/Title";
import SlideWrapper from "../slides-components/SlideWrapper";
import ChoiceButtons from "../slides-components/ChoiceButtons";
import TitleDescription from "../slides-components/TitleDescription";
import ProcediButton from "../slides-components/ProcediButton";

const options = ["si", "no"];

const SlideContributi = ({ urlParameters, navigate, queryString }) => {
  const [whichActive, setWhichActive] = useState(null);

  const handleProcedi = () => {
    setWhichActive(-1);
  };

  useEffect(() => {
    const newQueries = {
      ...urlParameters,
      currentStep: parseInt(urlParameters.currentStep) + 1,
      riduzioneContributi: whichActive === 0 ? +true : +false,
    };

    if (whichActive !== null) {
      navigate("/calcolatore/?" + queryString.stringify(newQueries));
    }
  }, [whichActive, urlParameters, queryString, navigate]);

  return (
    <SlideWrapper>
      {
        {
          0:
            urlParameters.gestionePrevidenziale !== "3" ? (
              <>
                <SlideMainTitle
                  text={"Vuoi applicare la riduzione dei contributi?"}
                />
                <TitleDescription
                  text={"Puoi ridurre i tuoi contributi del 35%"}
                  readMoreUrl={
                    "https://fidocommercialista.it/contributi-inps-per-soggetti-in-regime-forfettario-possibilita-di-richiedere-la-riduzione-al-65-per-artigiani-e-commercianti/"
                  }
                />
                <ChoiceButtons
                  options={options}
                  active={whichActive}
                  setActive={setWhichActive}
                />
              </>
            ) : (
              urlParameters.gestionePrevidenziale === "3" &&
              urlParameters.fullTime === "0" && (
                <>
                  <SlideMainTitle text={"Contributi previdenziali"} />
                  <TitleDescription
                    text={
                      "Come professionista verserai i contributi previdenziali e assistenziali alla Gestione Separata INPS (senza minimali)"
                    }
                  />
                  <ProcediButton handleClickCallback={handleProcedi} />
                </>
              )
            ),
          1: (
            <>
              <SlideMainTitle text={"Contributi previdenziali"} />
              <TitleDescription text={"Cassa privatizzata"} />
              <ProcediButton handleClickCallback={handleProcedi} />
            </>
          ),
          2: (
            <>
              <SlideMainTitle text={"Contributi previdenziali"} />
              <TitleDescription
                text={`Dato che la tua attività prevede il versamento dei contributi
                  ad una cassa privatizzata, verifica l’aliquota contributiva
                  prevista dalla tua cassa. <br> Allo step conclusivo potrai
                  modificare tale aliquota`}
              />
              <ProcediButton handleClickCallback={handleProcedi} />
            </>
          ),
          3:
            (urlParameters.gestionePrevidenziale === "0" ||
              urlParameters.gestionePrevidenziale === "1" ||
              urlParameters.gestionePrevidenziale === "2") &&
            urlParameters.fullTime === "1" ? (
              <>
                <SlideMainTitle text={"Contributi previdenziali"} />
                <TitleDescription
                  text={
                    "Avendo già una posizione previdenziale attiva con il tuo lavoro dipendente full-time sei esonerato dal pagare altri contributi"
                  }
                />
                <ContributiApprofondimento />
                <ProcediButton handleClickCallback={handleProcedi} />
              </>
            ) : (urlParameters.gestionePrevidenziale === "5" ||
                urlParameters.gestionePrevidenziale === "6") &&
              urlParameters.fullTime === "1" ? (
              <>
                <SlideMainTitle text={"Contributi previdenziali"} />

                <TitleDescription
                  text={
                    "Essendo già un dipendente full time, i contributi previdenziali (INPS) non saranno dovuti se lavori come impresa oppure subiranno una riduzione se lavori come libero professionista"
                  }
                />
                <p className="pb-8 ">
                  Nell'ultima slide potrai confrontare i due scenari
                  contributivi che il codice ATECO scelto ti permette di
                  scegliere
                </p>
                <ContributiApprofondimento />
                <ProcediButton handleClickCallback={handleProcedi} />
              </>
            ) : urlParameters.gestionePrevidenziale === "3" ? (
              <>
                <SlideMainTitle text={"Contributi previdenziali"} />
                <TitleDescription
                  text={
                    "Come professionista verserai i contributi previdenziali e assistenziali alla Gestione Separata INPS senza minimali.<br> Dato che sei anche dipendente full time puoi richiedere una riduzione contributiva.<br> Scegli se applicare tale riduzione."
                  }
                />
                <ChoiceButtons
                  options={options}
                  active={whichActive}
                  setActive={setWhichActive}
                />
              </>
            ) : urlParameters.cassa === "1" &&
              urlParameters.fullTime === "1" ? (
              <>
                <SlideMainTitle text={"Contributi previdenziali"} />
                <TitleDescription
                  text={
                    "In quanto sei già un lavoratore fulltime la tua Cassa potrà concederti una riduzione contributiva o un esonero.<br> Verifica questa possibilità consultando il regolamento della tua Cassa professionale."
                  }
                />
                <ContributiApprofondimento />
                <ProcediButton handleClickCallback={handleProcedi} />
              </>
            ) : (
              <>
                <SlideMainTitle text={"Contributi previdenziali"} />
                <TitleDescription
                  text={
                    "In quanto sei già un lavoratore fulltime verrà applicata un'aliquota ridotta per il calcolo dei contributi di questa partita iva"
                  }
                />
                <ProcediButton handleClickCallback={handleProcedi} />
              </>
            ),
        }[urlParameters.contributi]
      }
    </SlideWrapper>
  );
};

export default SlideContributi;

const ContributiApprofondimento = () => {
  return (
    <a
      href="https://fidocommercialista.it/contributi-previdenziali/"
      className="text-orange-400 underline pb-4 text-center pt-2"
    >
      Scopri come funzionano i contributi previdenziali &#8594;
    </a>
  );
};
